import React from "react";
import {
  Input,
  InputNumber,
  Row,
  Typography,
  Form,
  Select,
  Col,
  Tooltip,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import {
  labelConfig,
  staticConfig,
} from "../../../../customer/customer.config";

const { Text } = Typography;

const SettingsForm = (props) => {
  const {
    onFinish,
    form,
    lockinPeriodFrequencyTypeOptions,
    periodFrequencyTypeOptions,
    preClosurePenalInterestOnTypeOptions,
    taxGroupOptions,
    minDepositTypeOptions,
    maxDepositTypeOptions,
    inMultiplesOfDepositTermTypeOptions,
    checkWithHoldTax,
    handleWithHoldTax,
    preClosurePenalInterestStrategyOptions,
  } = props;
  const applyPenalInterest = Form.useWatch("preClosurePenalApplicable", form);

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      // initialValues={formData}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="isMandatoryDeposit"
            label={<Text strong>Is Deposit Mandatory?</Text>}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              options={staticConfig.yesOrNo}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="allowWithdrawal"
            label={<Text strong>Allow Withdrawals</Text>}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              options={staticConfig.yesOrNo}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="adjustAdvanceTowardsFuturePayments"
            label={
              <Tooltip title="Adjust advance payments toward future installments">
                <Text strong>
                  {BOM.SubstringFormat(
                    "Adjust advance payments toward future installments",
                    25
                  )}
                </Text>
              </Tooltip>
            }
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              options={staticConfig.yesOrNo}
              showSearch
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Lock-in Period</Text>}
            name="lockinPeriodFrequency"
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="lockinPeriodFrequencyType"
            label={<Text strong>Lock-in Period Frequency Type</Text>}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.lockinPeriodFrequencyType,
                "select"
              )}
              options={lockinPeriodFrequencyTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Minimum Deposit Term</Text>}
            name="minDepositTerm"
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <InputNumber
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.minimumDepositAmount
              )}
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="minDepositTermTypeId"
            label={<Text strong>Minimum Deposit Term Type</Text>}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.minimumDepositTermTypes,
                "select"
              )}
              options={minDepositTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>And Thereafter, In Multiples Of</Text>}
            name="inMultiplesOfDepositTerm"
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.thereAferTerms)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="inMultiplesOfDepositTermTypeId"
            label={<Text strong>In Multiples Of Deposit Term Type</Text>}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.inMultiplesOfType,
                "select"
              )}
              options={inMultiplesOfDepositTermTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Maximum Deposit Term</Text>}
            name="maxDepositTerm"
          >
            <InputNumber
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.maximumDepositAmount
              )}
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="maxDepositTermTypeId"
            label={<Text strong>Maximum Deposit Term Type</Text>}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.maximumDepositTermType,
                "select"
              )}
              options={maxDepositTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="preClosurePenalApplicable"
            label={
              <Text strong>Apply Penal Interest for Pre-mature Closure?</Text>
            }
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              options={staticConfig.yesOrNo}
              showSearch
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip title="Balance Required For Interest Calculation">
                <Text strong>
                  {BOM.SubstringFormat(
                    "Balance Required For Interest Calculation",
                    25
                  )}
                </Text>
              </Tooltip>
            }
            name="minBalanceForInterestCalculation"
          >
            <InputNumber
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.balanceRequiredForInterestCalculation
              )}
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Apply Penal Interest (less)</Text>}
            name={"preClosurePenalInterest"}
            rules={[
              {
                required: applyPenalInterest,
                message: "Required Field",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        {/* <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="preClosurePenalInterestOnTypeId"
            label={<Text strong>On</Text>}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              options={preClosurePenalInterestOnTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col> */}
        {applyPenalInterest && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="preClosurePenalInterestStrategyId"
              label={<Text strong>Penalty Calculation Method</Text>}
              rules={[
                {
                  required: applyPenalInterest,
                  message: "Required Field",
                },
              ]}
            >
              <Select options={preClosurePenalInterestStrategyOptions} showSearch />
            </Form.Item>
          </Col>
        )}
      </Row>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="withHoldTax"
            label={<Text strong>Is Withhold Tax Applicable?</Text>}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              onChange={handleWithHoldTax}
              options={staticConfig.yesOrNo}
              showSearch
            />
          </Form.Item>
        </Col>
        {checkWithHoldTax && (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text strong>Tax Group</Text>}
                name="taxGroupId"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.taxGroup)}
                  options={taxGroupOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
    </Form>
  );
};

export default SettingsForm;
